export default __webpack_public_path__ + "static/picto-pieces-black-2b8a71d608d4ca7f462f67420e867684.png";